export const environment = {
  production: true,
  env: 'dev',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_URL: 'https://api.dev.homhero.com.au/',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PCI_URL: 'https://secure.dev.homhero.com.au/pci',
};
